import React, { useState } from "react";

import Link from "next/link";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { colors, font } from "utils/styles";

import MarkdownContent from "components/Reusables/MarkdownContent";
import Badge from "components/Badge";
import { parseDate, getArticleCardHref, getJournalBadgeColor } from "utils/helpers";

import { ContenfulQuickLink } from "components/DebugTools";

export default function ArticleCard(props) {
	let fields = props.data;
	if (fields.fields) {
		fields = fields.fields;
	}

	const summary = fields.summary || fields.abstract;

	let publicationDate;
	if (fields.publicationDate) {
		const pubDate = parseDate(fields.publicationDate);
		publicationDate = `${pubDate.fullMonthName} ${pubDate.dayOfMonth}, ${pubDate.year}`;
	}
	return (
		<div className="articleCard">
			{process.env.APP_ENV !== "production" && (
				<ContenfulQuickLink
					title="Article Card Link"
					IR={true}
					position="absolute"
					width="15"
					entryId={props.entryId}
				/>
			)}
			<Row className="g-0 h-100 flex-column">
				<Col xs={12} className="flex-grow-1  d-flex flex-column justify-content-between  p-4">
					<div>
						{/* TODO: Bookmark Icon for later release */}
						{/* <BookmarkIcon id={props.data.sys.id} /> */}
						{/* Only show date if not part of a journal */}
						{!fields.journalEdition?.title && (
							<Row>
								<Col xs={"auto"}>
									<span className="pubDate">{publicationDate}</span>
								</Col>
							</Row>
						)}
						<Row className="align-items-center">
							{/* Featured label */}
							{fields.featured && !fields.isSponsored && (
								<Col xs={"auto"}>
									<Badge label="FEATURED" color="green" fontSize="15" />
								</Col>
							)}
							{/* Sponsored label */}
							{fields.isSponsored && (
								<Col xs={"auto"}>
									<Badge label="Sponsored" color="none" fontSize="15" />
								</Col>
							)}

							{fields.peerReview && (
								<Col xs={"auto"}>
									<Badge
										title={"Peer-Reviewed"}
										label={"Peer-Reviewed"}
										color={"red"}
										fontSize="15"
									/>
								</Col>
							)}

							{fields.journalEdition?.title && (
								<Col xs={"auto"}>
									<Badge
										// className={`${getJournalBadgeClass(fields.journalEdition?.journal?.title)}`}
										title={fields.journalEdition?.journal?.title}
										label={fields.journalEdition?.title}
										color={getJournalBadgeColor(fields.journalEdition?.journal?.title)}
										fontSize="15"
										url={`/publications/${fields.journalEdition.journal.journal[0].toLowerCase()}/${
											fields.journalEdition.sys.id
										}`}
										releaseDate={fields.journalEdition.releaseDate}
									/>
								</Col>
							)}
						</Row>

						{/* Title */}
						<Row>
							<Link href={getArticleCardHref(fields)}>
								<h3 className="title">{fields?.title}</h3>
							</Link>
						</Row>

						{/* Authors/ Pub date */}

						{/* meta summary */}
						{summary && (
							<MarkdownContent
								markdown={summary.length > 250 ? `${summary.slice(0, 250)}...` : summary}
							/>
							// <p className="content">{summary.length > 250 ? `${summary.slice(0, 250)}...` : summary}</p>
						)}
					</div>

					{/* REMOVED COMPETENCY TAGS TEMPORARILY PER REQUEST JEN/NANCY */}
					{/* <div>
						<div className="d-flex align-items-center">
							<div>
								{fields.primaryTag && <TagLabel tag={fields.primaryTag.title} />}
								{fields.secondaryTag && <TagLabel tag={fields.secondaryTag.title} />}
								{fields.tertiaryTag && <TagLabel tag={fields.tertiaryTag.title} />}
							</div>
						</div>
					</div> */}
				</Col>
			</Row>

			<style jsx="true">{`
				.pubDate {
					font-size: 10px;
					color: ${colors["lightBrown"]};
				}
				.bookmarkContainer {
					display: flex;
					flex: 1;
					justify-content: end;
				}

				.membersLink {
					color: ${colors.green};
					text-decoration: underline;
				}
				.articleCard {
					overflow: hidden;
					background: white;
					height: 100%;
					position: relative;
				}
				.title {
					font-size: 26;
					color: ${colors["darkBlue"]};
					font-weight: bold;
					line-height: 32px;
					font-family: ${font.Athelas};
					letter-spacing: 0px;
				}

				.content {
					font-size: 16;
					color: ${colors["lightBrown"]};
					line-height: 24px;
					font-family: ${font["default"]};
					letter-spacing: 0px;
				}
			`}</style>
		</div>
	);
}

// function getJournalBadgeClass(journal) {
// 	if (!journal) return "";
// 	if (journal.includes("PLJ") || journal.includes("Physician Leadership Journal")) {
// 		return "";
// 	} else if (journal.includes("Medical Practice Management") || journal.includes("JMPM")) {
// 		return "";
// 	} else if (journal.includes("Healthcare Administration Leadership") || journal.includes("HALMJ")) {
// 		return "greenRadialGradient";
// 	}
// }
